"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var usageStyles = require("./UsageMeter.scss");
/* End of UsageMeter Component Class */
var UsageMeter = /** @class */ (function (_super) {
    __extends(UsageMeter, _super);
    /* Usage Meter on Initialization */
    function UsageMeter(props) {
        var _this = _super.call(this, props) || this;
        /* Usage Meter on Initialization */
        /* Calculate the Percentage based on totalValue and completedValue values */
        _this.getUsageBarWidth = function () {
            var data = _this.props.data;
            var completedValue = data.completedValue, totalValue = data.totalValue;
            return (completedValue / totalValue) * 100;
        };
        /* Calculate the Percentage based on totalValue and completedValue values */
        /* Process Usage usageMeterLabel */
        _this.getUsageMeterTopLeftMessage = function () {
            var data = _this.props.data;
            var completedValue = data.completedValue, totalValue = data.totalValue, topLeftMessage = data.topLeftMessage;
            return completedValue + " of " + totalValue + " " + topLeftMessage;
        };
        /* Process Usage usageMeterLabel */
        /* Animate Usage Meters based on Their bar type */
        _this.animateUsageMeter = function () {
            var progressElements = document.querySelectorAll("[data-bar-type='animated']");
            var progressElementsLength = progressElements.length;
            for (var i = 0; i < progressElementsLength; i++) {
                var eachAnimatedElement = progressElements[i];
                if (eachAnimatedElement) {
                    var elementBounds = eachAnimatedElement.getBoundingClientRect();
                    var animElmStyle = eachAnimatedElement.getAttribute("style");
                    var bottom = elementBounds.bottom, top_1 = elementBounds.top;
                    if (!(top_1 > innerHeight || bottom < 0) && animElmStyle === "width: 0%;") {
                        // Toggle between in viewport and out of view port
                        eachAnimatedElement.setAttribute("style", "width: " + eachAnimatedElement.getAttribute("data-percentage"));
                        eachAnimatedElement.setAttribute("data-bar-type", "animate-completed");
                    }
                }
            }
        };
        /* Animate Usage Meters based on Their bar type */
        /* On Component Mount */
        _this.componentDidMount = function () {
            if (_this.props.options && _this.props.options.isAnimated) {
                _this.animateUsageMeter(); // On mount Handle Animated Bars in View Port
                /* Dynamically Taking ID for Animated Progressbar and Applying Animation in Viewport */
                document.addEventListener("scroll", _this.animateUsageMeter);
                /* Dynamically Taking ID for Animated Progressbar and Applying Animation in Viewport */
            }
        };
        /* On Component Mount */
        /* On Component Will Unmount */
        _this.componentWillUnmount = function () {
            if (_this.props.options && _this.props.options.isAnimated) {
                document.removeEventListener("scroll", _this.animateUsageMeter);
            }
        };
        /* On Component Will Unmount */
        /* Get Progressbar Color by Percentage Ranges */
        _this.progressColorByPercentage = function () {
            var options = _this.props.options;
            var fillColor = options.fillColor;
            if (fillColor && fillColor.length > 0) {
                var progressBarColorArray = fillColor.filter(function (eachColor) {
                    var minValue = eachColor.minValue, maxValue = eachColor.maxValue;
                    return _this.percentage >= minValue && _this.percentage <= maxValue;
                });
                if (progressBarColorArray.length > 0) {
                    return progressBarColorArray[0].color ? progressBarColorArray[0].color : "";
                }
                else {
                    return "";
                }
            }
            else {
                var result = "";
                if (_this.percentage >= 1 && _this.percentage <= 64) {
                    result = "bg-functional-dk-green";
                }
                else if (_this.percentage > 64 && _this.percentage < 100) {
                    result = "bg-functional-dk-orange";
                }
                else if (_this.percentage >= 100) {
                    result = "bg-functional-dk-red";
                }
                return result;
            }
        };
        /* Get Progressbar Color by Percentage Ranges */
        /* Render Usage Meter HTML */
        _this.render = function () {
            var _a = _this.props, data = _a.data, options = _a.options, testId = _a.testId, remainingProps = __rest(_a, ["data", "options", "testId"]);
            var urlLink = data.urlLink, usageMeterLabel = data.usageMeterLabel, description = data.description, urlText = data.urlText, daysRemaining = data.daysRemaining, completedValue = data.completedValue, totalValue = data.totalValue, topLeftMessage = data.topLeftMessage;
            var tabIndex = options.tabIndex, isAnimated = options.isAnimated, ariaLabel = options.ariaLabel;
            var leftusageMeterLabel = topLeftMessage && topLeftMessage !== "" ? _this.getUsageMeterTopLeftMessage() : ""; // Usage Meter Label on Top Bar
            var progressColor = _this.progressColorByPercentage();
            return (React.createElement("div", __assign({ "data-testid": testId, tabIndex: tabIndex }, remainingProps),
                leftusageMeterLabel && leftusageMeterLabel !== "" ? (React.createElement("div", { className: "usage-data-used flex color-ui-black font-medium type-sm mar-b-none justify-between" },
                    React.createElement("div", { className: "text-left mar-r-xs type-sm" }, leftusageMeterLabel),
                    daysRemaining ? React.createElement("div", { className: "text-right" },
                        " ",
                        daysRemaining) : "")) : (""),
                React.createElement("div", { className: "bg-ui-light-gray" +
                        " " +
                        usageStyles.usageMeter +
                        " " +
                        "overflow-hidden pad-none rel", role: "progressbar", "aria-label": ariaLabel ? ariaLabel : "", "aria-valuenow": completedValue, "aria-valuemin": 0, "aria-valuemax": totalValue, "aria-valuetext": Math.floor(_this.percentage) + "% usage" },
                    React.createElement("div", { "data-bar-type": isAnimated ? "animated" : "non-animated", className: usageStyles.bar + " " + "height-full flex" + " " + progressColor, "data-percentage": _this.percentage + "%", style: { width: (isAnimated ? "0" : _this.percentage) + "%" } })),
                description || usageMeterLabel || urlLink || urlText ? (React.createElement("div", { className: "color-ui-dark-gray font-regular type-sm mar-b-none usage-desc-label" },
                    description ? (React.createElement("span", { "aria-hidden": "false" }, description)) : usageMeterLabel ? (React.createElement("span", { "aria-hidden": "false" }, usageMeterLabel)) : (""),
                    urlLink || urlText ? (React.createElement("a", { href: urlLink ? urlLink : undefined, className: usageMeterLabel
                            ? "block link-text3 nowrap font-medium"
                            : "link-text3 font-medium" }, urlText ? (React.createElement("span", { "aria-hidden": "false" }, urlText)) : (React.createElement("span", { "aria-hidden": "false" }, "Learn why")))) : (""))) : ("")));
        };
        var _a = props.data, totalValue = _a.totalValue, completedValue = _a.completedValue;
        _this.percentage = _this.getUsageBarWidth();
        try {
            if (totalValue <= 0) {
                throw new Error("Total value cannot be less than 1");
            }
            else if (completedValue < 0 || completedValue > totalValue) {
                throw new Error("Completed Value cannot be less than 1 or greater than total value");
            }
        }
        catch (error) {
            props.data.totalValue = 1;
            props.data.completedValue = 1;
        }
        return _this;
    }
    /* Default Properties */
    UsageMeter.defaultProps = {
        options: {
            fillColor: [],
        },
    };
    return UsageMeter;
}(React.PureComponent));
/* End of UsageMeter Component Class */
exports.default = UsageMeter;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/UsageMeter/UsageMeter.js
// module id = 1833
// module chunks = 8